import * as React from 'react';
import axios from 'axios';

//CORE COMPONENTS
import { 
    ThemeProvider, 
    styled 
} from '../../../components-core/packages/components-core/dist/theme-provider/index';

//LAYOUT
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';

//INPUTS
import { TextArea } from '../../../components-core/packages/components-core/dist/text-area/index';
import { Checkbox } from '../../../components-core/packages/components-core/dist/checkbox/index';
import { Select } from '../../../components-core/packages/components-core/dist/select/index';

//STYLE COMPONENTS
import { Text, TextAppearance, WhiteSpace } from '../../../components-core/packages/components-core/dist/text';
import { Link } from '../../../components-core/packages/components-core/dist/link';

//CUSTOM COMPONENTS
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';



const TopContainer = styled.div`
    width: 100vw;
    background: ${props => props.inverted && ('rgb(0,67,122)')};
    background: ${props => props.inverted && ('-moz-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%)')};
    background: ${props => props.inverted && ('-webkit-linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%)')};
    background: ${props => props.inverted && ('linear-gradient(325deg, rgba(0,67,122,1) 0%, rgba(0,30,80,1) 100%)')};
    filter: ${props => props.inverted && ('progid:DXImageTransform.Microsoft.gradient(startColorstr="#00437a",endColorstr="#001e50",GradientType=1)')};
`;

const initialState = {
    name: null,
    surname: null,
    selectedOption: "-1",
    dealerList: [],
    carName: null,
    carId: null,
    phone: null,
    pr1: false,
    pr2: false,
    isSuccess: false,
    mail:"",
    nameError: "",
    emailError: "",
    telephoneError: "",
}

class LeadSection extends React.Component {

    state=initialState;


    async componentDidMount() {
        //https://ticariarac.vw.com.tr/jsPost/GetDealers.ashx
        /**
         * Test için: axios.get('https://cors-anywhere.herokuapp.com/https://ticariarac.vw.com.tr/jsPost/GetDealers.ashx', {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
         */
        
        await  axios.get('https://ticariarac.vw.com.tr/jsPost/GetDealers.ashx')
            .then(response => {
                this.setState({ dealerList: response.data});
            })
            .catch(error => {
                console.log(error)
            })
        
        await carList.forEach(data => {
            if (this.props.custom.includes(data.car)) {
                this.setState({ carName: data.car, carId: data.id });
            }
        })
    }

    validate =() =>{
        let nameError = "";
        let emailError = "";
        let telephoneError="";


        if(!this.state.mail.includes('@')){
            emailError = 'E-mail aktif olarak bulunamadı'
        }
        if(emailError){
         this.setState({emailError});
         return false;
        }
        return true;
    }
    
    handleSubmit = event => {
        event.preventDefault();
        const isValid = this.validate();
        if(isValid){
            console.log(this.state)
            this.setState('initialState')
        }
    }

    renderTitle() {
        const { custom } = this.props;

        return (
            <Container 
                gutter={ContainerGutter.dynamic0100} 
                horizontalAlign={titleAlignnent}
            >
                <Text appearance={TextAppearance.headline0300}>
                    Hayallerinizdeki Volkswagen' e <br />
                    <Text bold> sadece bir adım uzaktasınız.</Text> 
                </Text>
                <Text appearance={TextAppearance.copy0150}>
                    {custom} hakkında ayrıntılı bilgi almak için formu doldurun, 
                    sizi dakikalar içinde arayıp bilgilendirelim.
                </Text>
                <div style={{color:'red'}}>
                    {this.state.nameError}
                    {this.state.telephoneError}
                    {this.state.emailError}
                </div>
            </Container>
        )
    }

    async postData() {
        const { 
            name, 
            surname, 
            phone, 
            mail,
            pr1,
            pr2,
            carId,
            selectedOption,
            carName,
            isSuccess
        } = this.state;


        if (!name || !surname || !phone || !mail || selectedOption === "-1") {
            alert('Lütfen tüm alanları eksiksiz doldurunuz.');
            return;
        }

        if (isSuccess) {
            alert('Formunuz zaten yollanmıştı, yakında sizinle iletişime geçeceğiz.');
            return;
        }

        if (phone && phone.length !== 11) {
            alert('Lütfen telefon numaranızı kontrol edin. Örnek: 01234567899');
            return;
        }


        let dealerId = null;
        await this.state.dealerList.forEach(data => {
            if (data.FirmCode === selectedOption) {
                dealerId = data.FirmID
            }
        })
        var data = {};
        if(this.props.custom1 === '3750'){
            var dataForm = {
                "name": name,
                "surname":surname,
                "phone": phone,
                "model": carId ? carId : "24",
                "modelName": "Crafter",
                "source": "Crafter" + " Lead Form",
                "dealerId": dealerId.toString(),
                "dealerText": selectedOption,
                "projectId": this.props.custom1 ? this.props.custom1 : '3668',
                "formName": this.props.custom ? this.props.custom : "Siz İsteyin Biz Gelelim",
                "terms":"1",
                "formguid":"88f99c03-8da0-4f66-af28-e019dcfe310c",
                "contactPermission": pr2 && pr1
            }
        }else {
            var dataForm = {
                "name": name,
                "surname":surname,
                "phone": phone,
                "model": carId ? carId : "20",
                "modelName": carName ? carName : "Caddy",
                "source": carName + " Lead Form",
                "dealerId": dealerId.toString(),
                "dealerText": selectedOption,
                "projectId": this.props.custom1 ? this.props.custom1 : '3668',
                "formName": this.props.custom ? this.props.custom : "Siz İsteyin Biz Gelelim",
                "terms":"1",
                "formguid":"88f99c03-8da0-4f66-af28-e019dcfe310c",
                "contactPermission": pr2 && pr1
            }
        }
        data = dataForm;
    
        
        //realUrl: https://ticariarac.vw.com.tr/jsPost/SetLeadForm.ashx
        //testurl: https://cors-anywhere.herokuapp.com/https://ticariarac.vw.com.tr/jsPost/SetLeadForm.ashx
        const url = 'https://ticariarac.vw.com.tr/jsPost/SetLeadForm.ashx';

        axios.post(url, data)
            .then((response) => {
                if (response.data.success) {
                    this.setState({ isSuccess: true });
                    alert('Teşekkürler! Sizinle en kısa sürede iletişime geçeceğiz.');
                }
            })
            .catch((error) => {
                alert('Bir hata meydana geldi. Lütfen tekrar deneyiniz.')
            })
    }

    renderForms() {
        return (
            <form>
            <Container 
                stretchContent={true} 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.dynamic0050}
            >
                <TextArea
                    label={'İsim'}
                    placeholder="Lütfen isminizi girin."
                    onChange={(event) => this.setState({ name: event.target.value })}
                    value={this.state.name}
                    required={true}
                />
                <TextArea
                    label={'Soyisim'}
                    placeholder="Lütfen soyisiminizi girin."
                    onChange={(event) => this.setState({ surname: event.target.value  })}
                    value={this.state.surname}
                    required={true}
                />
                <TextArea
                    label={'Telefon'}
                    placeholder={'Lütfen telefon numaranızı girin.'}
                    onChange={(event) => this.setState({ phone: event.target.value  })}
                    value={this.state.phone}
                    required={true}
                />
                <TextArea
                    label={'E-Posta'}
                    placeholder={'Lütfen e-posta adresinizi girin.'}
                    onChange={(event) => this.setState({ mail: event.target.value  })}
                    value={this.state.mail}
                    required={true}
                />

                <Text bold appearance={TextAppearance.copy0150}>
                    Hangi yetkili satış noktasından bilgi almak istersiniz?
                </Text>

                <Select
                    value={this.state.selectedOption}
                    name="Bayi"
                    onChange={(event) => {
                        this.setState({ selectedOption: event.target.value })
                    }}
                    autoComplete={'given-name'}
                    key={this.state.selectedOption + '1'}
                >
                    <option
                        label={'Seçiniz'}
                        key={"0"}
                    >
                        {'Seçiniz'}
                    </option>
                    {
                        this.state.dealerList.map(data => 
                            <option 
                                label={data.car}
                                key={data.id}
                            >
                                {' ' + data.FirmCode}
                            </option>
                        )
                    }
                </Select>

                <Text whiteSpace={WhiteSpace.preLine}>
                    Kullanım Şartları ve Gizlilik/Kişisel Verilerin Korunması Politikası ve 
                    Aydınlatma Metni'ne 
                    <Link 
                        target={'_blank'} 
                        href={'https://ticariarac.vw.com.tr/kisisel-veri'}
                    >
                        &nbsp;buradan&nbsp;
                    </Link> 
                    ulaşabilirsiniz. {'\n'}
                    Ticari İletişim İzni Aydınlatma Metni’ne 
                    <Link 
                        target={'_blank'} 
                        href={'https://ticariarac.vw.com.tr/kullanim'} 
                    >
                        &nbsp;buradan&nbsp;
                    </Link>
                    ulaşabilirsiniz.
                </Text>

                <Checkbox
                    value="1"
                    label={label(terms1)}
                    onClick={() => this.setState({ pr1: true })}
                />
                <Checkbox
                    value="1"
                    label={label(terms2)}
                    onClick={() => this.setState({ pr2: true })}
                />
            </Container>
            </form>
        )
    }

    renderLeft() {
        return (
            <Container 
                stretchContent={true} 
                padding={leftContainerPadding} 
                wrap={ContainerWrap.always}
                gutter={ContainerGutter.dynamic0200}
            >
                {this.renderForms()}
                {this.renderButton()}
            </Container>
        )
    }


   handleChange = (e)=> {
    if(this.state.mail>0 && this.state.name>0 && this.state.surname>0){
        this.setState(
            {
                disabled : false
            }
            )
    }
}


    renderButton() {
        return (
            <Container stretchContent={true} padding={buttonContainerPadding} >
                <Button appearance={ButtonAppearance.Primary} stretchContent={true} onClick={() => this.postData()} disabled={!(this.state.name && this.state.surname && this.state.mail && this.state.phone )} onChange={this.handleChange()}>
                    Bilgi al
                </Button>
            </Container>
        )
    }

    renderImage() {
        return (
            <BreakpointWrapper min={Breakpoints.b1280}>

            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center} 
                verticalAlign={ContainerVerticalAlignment.center}
            >
                <img 
                    src={require('../../images/lead-white.png')} 
                    width={'60%'}
                    style={{marginTop:'30%', marginLeft:'20%', }}
                    height={'60%'}
                />
            </Container>
            </BreakpointWrapper>
        )
    }
 
    render() {
        return (
            <div id="scroll">
            <IntegratorRoot>
                <ThemeProvider theme={this.props.inverted ? 'inverted' : 'main'}>
                    <TopContainer inverted={this.props.inverted} >
                        <Container 
                            stretchContent={true} 
                            padding={{ top: ContainerGutter.dynamic0200, bottom: ContainerGutter.dynamic0200 }} 
                        >
                            <Layout appearance={layoutAppearance}>
                                {this.renderLeft()}
                                {this.renderImage()}
                            </Layout>
                        </Container>
                    </TopContainer>
                </ThemeProvider>
            </IntegratorRoot>
            </div>
        )  
    }
}

const label = (text) => (
    <Text appearance={TextAppearance.copy0100} >{text}</Text>
)

const titleAlignnent = {
    [Breakpoints.default]: ContainerHorizontalAlignment.flexStart,
    [Breakpoints.b960]: ContainerHorizontalAlignment.center,
    [Breakpoints.b1280]: ContainerHorizontalAlignment.flexStart
}

const buttonContainerPadding = {
    left: {
        [Breakpoints.default]: null,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: null
    },
    right: {
        [Breakpoints.default]: null,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid004,
    }
}

const leftContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid001
    }
}

const layoutAppearance = {
    [Breakpoints.default]: [
        { name: 'a', columns: 24 },
        { name: 'b', columns: 0 }
    ],
    [Breakpoints.b1280]: [
        { name: 'a', columns: 12 },
        { name: 'b', columns: 12 }
    ]
}


const terms1 = 'Şirketiniz tarafından sunulan mal ve hizmetlerinin pazarlanması, kampanya, tanıtım ve etkinlik süreçlerinin planlanması, takibi ve geliştirilmesi amacıyla iletişime geçilmesi,';
const terms2 = 'Kişiselleşirilmiş reklamcılık uygulamaları (beğeni ve tercihlerinize uygun olarak, tarafınıza çeşitli avantaların sağlanıp sunulabilmesi ve kişisel olarak size uygun reklam, tanıtım, pazarlama, etkinlik yönetimi, bilgilendirme, promosyon, kampanya bildirimi, veri zenginleştirme, çapraz cihaz hedefleme, veri yönetim platformları, sosyal medya platformları ve arama motorları aracılığıyla reklam gösterimi) amacıyla izin veriyorum.';

export default LeadSection;

const carList = [
    {
        id: '22',
        car: 'Amarok'
    },
    {
        id: '20',
        car: 'Caddy'
    },
    {
        id: '23',
        car: 'Caravelle'
    },
    {
        id: '24',
        car: 'Crafter'
    },
    {
        id: '21',
        car: 'Transporter'
    }
]
